import React from 'react';
import Spinner from 'react-spinkit';

const InfoBadgeComponent = ({ name, data, progressData, is_loading }) => {

    return <div className='cards-badge' >
        <div className='cards-badge-header'>
            <p>{name}</p>
        </div>

        <div className='cards-badge-body'>
            {is_loading ? (
                    <div
                        className='spinner-loading'
                        style={{ paddingTop: '15px', paddingBottom: '65px', textAlign: 'center' }}
                    >
                        <Spinner name='folding-cube' fadeIn='none' />
                    </div>
            ) : (
                <div className='cards-badge-text'>
                    <p className='cards-badge-value'>{Math.floor(data).toLocaleString('en-US', { useGrouping: true }).replace(/,/g, ' ')}</p>
                    {progressData && (
                        <div className='cards-badge-container'>
                            <progress
                                className='cards-badge-progress'
                                value={progressData.value}
                                max={progressData.max}>
                            </progress>
                            <div class="progress-value">{progressData.value}%</div>
                        </div>
                    )}
                </div>
            )}
        </div>
    </div>;
};

export default InfoBadgeComponent;